import React, { Component } from 'react';

function HomeBanner() {
  return (
    <div className="home-banner">
      <img src="/static/images/Opsites-MyAccount-Banner.jpg" alt="home-banner" />
    </div>
  );
}

export default HomeBanner;

// export default class HomeBanner extends Component {
//   static propTypes = {};

//   render() {
//     return (
//       <div className="home-banner">
//         <img src="/static/images/logged_in_banner.png" alt="home-banner" />
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/themes/my-account/HomeBanner/HomeBanner.js